__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "prana-frontend";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/api", "5.1.1", function() { return Promise.all([__webpack_require__.e(691), __webpack_require__.e(176)]).then(function() { return function() { return __webpack_require__(3691); }; }); });
			register("@azure/msal-browser", "2.35.0", function() { return __webpack_require__.e(918).then(function() { return function() { return __webpack_require__(4918); }; }); });
			register("@prana/global-states", "1.2.5", function() { return function() { return __webpack_require__(7021); }; }, 1);
			register("@prana/shared-fe-components", "1.22.43", function() { return Promise.all([__webpack_require__.e(302), __webpack_require__.e(773)]).then(function() { return function() { return __webpack_require__(4302); }; }); });
			register("@prana/shared-fe-toast", "1.0.3", function() { return Promise.all([__webpack_require__.e(866), __webpack_require__.e(773)]).then(function() { return function() { return __webpack_require__(8866); }; }); });
			register("clsx", "1.2.1", function() { return __webpack_require__.e(182).then(function() { return function() { return __webpack_require__(8182); }; }); });
			register("graphql-request", "6.1.0", function() { return Promise.all([__webpack_require__.e(219), __webpack_require__.e(145)]).then(function() { return function() { return __webpack_require__(9219); }; }); });
			register("graphql", "15.8.0", function() { return __webpack_require__.e(901).then(function() { return function() { return __webpack_require__(2901); }; }); });
			register("graphql", "15.8.0", function() { return __webpack_require__.e(340).then(function() { return function() { return __webpack_require__(7340); }; }); });
			register("graphql", "16.8.1", function() { return __webpack_require__.e(199).then(function() { return function() { return __webpack_require__(199); }; }); });
			register("react-dom", "18.2.0", function() { return function() { return __webpack_require__(4164); }; }, 1);
			register("react-router-dom", "6.8.1", function() { return function() { return __webpack_require__(7383); }; }, 1);
			register("react", "18.2.0", function() { return function() { return __webpack_require__(2791); }; }, 1);
			register("swr", "2.3.3", function() { return __webpack_require__.e(998).then(function() { return function() { return __webpack_require__(3998); }; }); });
			initExternal(621);
			initExternal(398);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};